import { StopPriceInputController } from 'components/PlaceOrderStopPriceInput/StopPriceInputController'
import { memo } from 'react'
import {
  useCurrentSpotSymbol,
  useSpotSelectedOrderMode,
} from 'store/spot/hooks'
import { OrderModeNames } from 'store/spot/types'
import { SpotLimitPriceInput } from './LimitPriceInput'
import { SpotMarketPriceInput } from './MarketPriceInput'
import { SpotSpotMarketPriceInput } from './StopMarketPriceInput'

export const PriceInput = memo(() => {
  const spotSelectedOrderType = useSpotSelectedOrderMode()
  const { quoteScale = 0 } = useCurrentSpotSymbol()

  if (
    spotSelectedOrderType.name === OrderModeNames.Limit ||
    spotSelectedOrderType.name === OrderModeNames.Iceberg
  ) {
    return <SpotLimitPriceInput />
  }

  if (spotSelectedOrderType.name === OrderModeNames.Market) {
    return <SpotMarketPriceInput />
  }

  if (spotSelectedOrderType.name === OrderModeNames.StopLimit) {
    return (
      <>
        <StopPriceInputController quoteScale={quoteScale} />
        <SpotLimitPriceInput />
      </>
    )
  }

  if (spotSelectedOrderType.name === OrderModeNames.StopMarket) {
    return (
      <>
        <StopPriceInputController quoteScale={quoteScale} />
        <SpotSpotMarketPriceInput />
      </>
    )
  }

  return null
})
